'use client'

import React, { createContext, useContext, useMemo, useState, type ReactNode } from 'react'

type WorkspaceNavigationContextValue = {
  isOpen: boolean
  open: () => void
  close: () => void
  toggle: () => void
}

const WorkspaceNavigationContext = createContext<WorkspaceNavigationContextValue>({
  isOpen: false,
  open: () => undefined,
  close: () => undefined,
  toggle: () => undefined,
})

export function WorkspaceNavigationProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false)

  const value = useMemo(
    () => ({
      isOpen,
      open: () => setIsOpen(true),
      close: () => setIsOpen(false),
      toggle: () => setIsOpen((current) => !current),
    }),
    [isOpen]
  )

  return <WorkspaceNavigationContext.Provider value={value}>{children}</WorkspaceNavigationContext.Provider>
}

export function useWorkspaceNavigation() {
  return useContext(WorkspaceNavigationContext)
}
